<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title>Sign Up</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <form #f="ngForm" class="ion-padding" (ngSubmit)="onRegister(f)">
    <ion-grid>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-list>
            <ion-item color="lightmimbo">
              <ion-label position="floating">E-Mail</ion-label>
              <ion-input
                type="email"
                name="email"
                ngModel
                required
                email
                #emailCtrl="ngModel"
              ></ion-input>
            </ion-item>
            <ion-item
              *ngIf="!emailCtrl.valid && emailCtrl.touched"
              lines="none"
              color="lightmimbo"
            >
              <ion-text color="danger"
                ><small>Enter a valid email.</small></ion-text
              >
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-label position="floating">Username</ion-label>
              <ion-input
                type="username"
                name="username"
                (ionInput)="resetUsername()"
                (ionBlur)="checkUsername($event)"
                ngModel
                required
                #usernameCtrl="ngModel"
              ></ion-input>
            </ion-item>
            <ion-item lines="none" color="lightmimbo" *ngIf="usernameExists">
              <ion-text color="danger"
                ><small>Username already taken.</small></ion-text
              >
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-label position="floating">First Name</ion-label>
              <ion-input
                type="text"
                name="firstName"
                ngModel
                required
                #firstNameCtrl="ngModel"
              ></ion-input>
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-label position="floating">Last Name</ion-label>
              <ion-input
                type="text"
                name="lastName"
                ngModel
                required
                #lastNameCtrl="ngModel"
              ></ion-input>
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-label position="floating">Password</ion-label>
              <ion-input
                type="password"
                name="password"
                ngModel
                required
                minlength="6"
                #passwordCtrl="ngModel"
              ></ion-input>
            </ion-item>
            <ion-item
              color="lightmimbo"
              *ngIf="!passwordCtrl.valid && passwordCtrl.touched"
              lines="none"
            >
              <ion-text color="danger">
                <small
                  >Password should be at least 6 characters long.</small
                ></ion-text
              >
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-label position="floating">Confirm Password</ion-label>
              <ion-input
                type="password"
                name="confirmPassword"
                ngModel
                required
                #confirmPasswordCtrl="ngModel"
              ></ion-input>
            </ion-item>
            <ion-item *ngIf="!passwordsMatch" lines="none" color="lightmimbo">
              <ion-text color="danger"
                ><small>Passwords do not match.</small></ion-text
              >
            </ion-item>
          </ion-list>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          sizeMd="10"
          offsetMd="1"
          sizeXl="6"
          offsetXl="3"
          class="ion-text-center"
        >
          <ion-button
            color="primary"
            type="submit"
            [disabled]="!f.valid"
            class="signup-btn"
            >Sign Up<ion-icon slot="start" name="person-add-outline"></ion-icon
          ></ion-button>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-text
            color="primary"
            (click)="goToSignin()"
            class="link forgot-password"
            >Already have an account? Click here to sign in!</ion-text
          >
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>
